import { render, staticRenderFns } from "./ResetPasswordDialogComponent.vue?vue&type=template&id=70521538"
import script from "./ResetPasswordDialogComponent.vue?vue&type=script&lang=js"
export * from "./ResetPasswordDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports